import { render, staticRenderFns } from "./BankStatement.vue?vue&type=template&id=2c9002f4&scoped=true&"
import script from "./BankStatement.vue?vue&type=script&lang=js&"
export * from "./BankStatement.vue?vue&type=script&lang=js&"
import style0 from "./BankStatement.vue?vue&type=style&index=0&id=2c9002f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9002f4",
  null
  
)

export default component.exports